import * as tslib_1 from "tslib";
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { lazyRemoveFavoriteSearch } from 'owa-mail-favorites-store';
import { selectFavoriteSearch } from 'owa-mail-folder-forest-actions';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { isSearchInFavorites, lazyUpdateFavoritePosition, ToggleFavoriteButton, } from 'owa-favorites';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from 'owa-mail-folder-view';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
var styles = require('./FavoriteNode.scss');
var SearchNodeComputedState = /** @class */ (function () {
    function SearchNodeComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(SearchNodeComputedState.prototype, "isSelected", {
        get: function () {
            return this.props.searchQuery == getSelectedNode().id;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], SearchNodeComputedState.prototype, "isSelected", null);
    return SearchNodeComputedState;
}());
var FavoriteSearchNode = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteSearchNode, _super);
    function FavoriteSearchNode(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (evt) {
            evt.stopPropagation();
            selectFavoriteSearch(_this.props.searchQuery);
        };
        _this.renderToggleFavorite = function () {
            return (React.createElement(ToggleFavoriteButton, { isInFavorites: isSearchInFavorites(_this.props.searchQuery), onClick: _this.removeFavoriteSearch, iconStyles: styles.favoriteButton }));
        };
        _this.removeFavoriteSearch = function (evt) {
            evt.stopPropagation();
            lazyRemoveFavoriteSearch.importAndExecute(_this.props.searchQuery, 'FolderNodeFavoriteButton');
        };
        // VSO 23480 - [FavoritesDND]Refactor the common DND code into a base component
        _this.getDragData = function () {
            var favoriteNodeDragData = {
                itemType: DraggableItemTypes.FavoriteNode,
                favoriteId: _this.props.favoriteId,
                favoriteType: 3 /* Search */,
                displayName: _this.props.searchQuery,
            };
            return favoriteNodeDragData;
        };
        _this.getDragPreview = function (favoriteNodeDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragPreview;
            elem.innerText = favoriteNodeDragData.displayName;
            return elem;
        };
        _this.canDrop = function (dragData) {
            return dragData.itemType === DraggableItemTypes.FavoriteNode;
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var draggedFavorite, dropTargetId, dragTargetId, updateFavoritePosition;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canDrop(dragData)) {
                            return [2 /*return*/];
                        }
                        draggedFavorite = dragData;
                        dropTargetId = this.props.favoriteId;
                        dragTargetId = draggedFavorite.favoriteId;
                        return [4 /*yield*/, lazyUpdateFavoritePosition.import()];
                    case 1:
                        updateFavoritePosition = _a.sent();
                        updateFavoritePosition(dragTargetId /* idToUpdate */, dropTargetId /* destinationFolderId */, draggedFavorite.favoriteType);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.computedState = new SearchNodeComputedState(_this.props);
        return _this;
    }
    FavoriteSearchNode.prototype.render = function () {
        return (React.createElement(DragAndDroppable, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: this.props.dropViewState, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement(TreeNode, { customIcon: "Search" /* Search */, displayName: this.props.searchQuery, isRootNode: false, key: this.props.searchQuery, isDroppedOver: this.props.dropViewState.isDragOver, onClick: this.onClick, isSelected: this.computedState.isSelected, renderRightCharmHover: this.renderToggleFavorite })));
    };
    FavoriteSearchNode = tslib_1.__decorate([
        observer
    ], FavoriteSearchNode);
    return FavoriteSearchNode;
}(React.Component));
export default FavoriteSearchNode;
//# sourceMappingURL=FavoriteSearchNode.js.map